import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { usePersonsServiceGetPersonByIdEndpoint } from 'src/api/queries'
import { getFullName } from 'src/features/users/utils'

export const usePersonBreadcrumb = (personId?: string) => {
  const { t } = useTranslation()

  const { data: person, isLoading: isLoadingPerson } =
    usePersonsServiceGetPersonByIdEndpoint(
      { id: String(personId) },
      [personId],
      {
        enabled: !!personId
      }
    )

  const fullName = useMemo(
    () =>
      person
        ? `${t('common.person')} - ${getFullName(person?.lastName, person?.firstName)} ${person?.isAnonymous ? `(${t('epidemiology.patient_status.anonymous')})` : ''}`
        : '',
    [t, person]
  )

  const breadcrumbItems = useMemo(
    () => [
      { title: t('menu.persons') },
      ...(person ? [{ title: fullName }] : [])
    ],
    [t, person, fullName]
  )

  return { breadcrumbItems, fullName, person, isLoadingPerson }
}
